import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Checkbox, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import Van from "../assets/svg/Van.svg";
import './ArrangeOrders.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { AGENT_ORDERS } from '../URLs/Apis';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ArrangeOrders = () => {
  const {id} = useParams()
  const {user} = useSelector((state) => state.auth)
  const token = user?.token
  const [agentOrders,setAgentOrders]=useState([])
  const [distanceDropdownOpen, setDistanceDropdownOpen] = useState(false);
  const [profitDropdownOpen, setProfitDropdownOpen] = useState(false);
  const [timeDropdownOpen, setTimeDropdownOpen] = useState(false);

  const toggleDistanceDropdown = () => {
    setDistanceDropdownOpen(!distanceDropdownOpen);
    setProfitDropdownOpen(false);
    setTimeDropdownOpen(false);
  };

  const toggleProfitDropdown = () => {
    setProfitDropdownOpen(!profitDropdownOpen);
    setDistanceDropdownOpen(false);
    setTimeDropdownOpen(false);
  };

  const toggleTimeDropdown = () => {
    setTimeDropdownOpen(!timeDropdownOpen);
    setDistanceDropdownOpen(false);
    setProfitDropdownOpen(false);
  };
const getOrderByVehicle = async  ()=>{
  try {
    const response = await axios.get(`${AGENT_ORDERS}?vehicle_id=${id}`,{
      headers:{Authorization:`Bearer ${token}`,}
    })
    console.log(response);
    setAgentOrders(response.data.data.orders)
  } catch (error) {
    console.log(error);
    
  }
}
useEffect(() => {
  getOrderByVehicle()
}, [])
  return (
    <Box className="arrange-orders-container">
      <Grid container className="top-section row align-items-center">
        <Grid item md={6} xs={18} className="van-container">
          {/* ... (Rest of your van and filter code - no changes here) */}
          <Grid>
            <Grid container>
              <Grid item md={12}>
                <div className="d-flex">
                  <div className='w-100'>
                    <Typography variant="h5" className="van-title">Van #01</Typography>
                    <img src={Van} alt="Van" className="van-image" />
                    <Typography className="working-hours">Working hours 6 / 8 hours</Typography>
                    {/* SVG Progress Bar */}
                    <div className="progress-bar">
                      <svg xmlns="http://www.w3.org/2000/svg" width="243" height="9" viewBox="0 0 243 9" fill="none">
                        <rect y="0.75" width="243" height="8" rx="4" fill="#DADADA" />
                        <rect y="0.75" width="163.778" height="8" rx="4" fill="#FEB91E" />
                      </svg>
                    </div>
                  </div>

                  <div className='inputForVanArrangOrders'>
                    <div className='d-flex flex-column gap-2'>
                      <Typography className="working-hours">Start Point</Typography>
                      <input
                        className="filter-text-field form-control "
                        type="text"
                        placeholder="Latitude"
                      />
                      <input
                        className="filter-text-field form-control"
                        type="text"
                        placeholder="Longitude"
                      />
                    </div>
                  </div>


                </div>
              </Grid>
            </Grid>

            <Grid item md={13}>
              <Grid className="filters-section">
                <Grid item className="filter-item">
                  <Typography variant="subtitle2" className="filter-label">Distance</Typography>
                  <div className="dropdown">
                    <button
                      className="btn btn-light dropdown-toggle"
                      type="button"
                      id="dropdownMenuButtonDistance"
                      aria-haspopup="true"
                      aria-expanded={distanceDropdownOpen}
                      onClick={toggleDistanceDropdown}
                    >
                      Select Distance
                    </button>
                    <div className={`dropdown-menu ${distanceDropdownOpen ? 'show' : ''}`} aria-labelledby="dropdownMenuButtonDistance">
                      <a className="dropdown-item" href="#">10 km</a>
                      <a className="dropdown-item" href="#">20 km</a>
                      <a className="dropdown-item" href="#">30 km</a>
                    </div>
                  </div>
                </Grid>

                <Grid item className="filter-item">
                  <Typography variant="subtitle2" className="filter-label">Profit</Typography>
                  <div className="dropdown">
                    <button
                      className="btn btn-light dropdown-toggle"
                      type="button"
                      id="dropdownMenuButtonProfit"
                      aria-haspopup="true"
                      aria-expanded={profitDropdownOpen}
                      onClick={toggleProfitDropdown}
                    >
                      Select Profit
                    </button>
                    <div className={`dropdown-menu ${profitDropdownOpen ? 'show' : ''}`} aria-labelledby="dropdownMenuButtonProfit">
                      <a className="dropdown-item" href="#">$100</a>
                      <a className="dropdown-item" href="#">$200</a>
                      <a className="dropdown-item" href="#">$300</a>
                    </div>
                  </div>
                </Grid>

                <Grid item className="filter-item">
                  <Typography variant="subtitle2" className="filter-label">Time</Typography>
                  <div className="dropdown">
                    <button
                      className="btn btn-light dropdown-toggle"
                      type="button"
                      id="dropdownMenuButtonTime"
                      aria-haspopup="true"
                      aria-expanded={timeDropdownOpen}
                      onClick={toggleTimeDropdown}
                    >
                      Select Time
                    </button>
                    <div className={`dropdown-menu ${timeDropdownOpen ? 'show' : ''}`} aria-labelledby="dropdownMenuButtonTime">
                      <a className="dropdown-item" href="#">Morning</a>
                      <a className="dropdown-item" href="#">Afternoon</a>
                      <a className="dropdown-item" href="#">Evening</a>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
        </Grid>

        {/* Embedded Google Map */}
        <Grid item md={6} xs={12} className="map-container">
          <div className="w-70%">
            <div className="overflow-hidden w-100 ">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d161458.96358337457!2d31.487165312378934!3d30.00529577757057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2seg!4v1735571701502!5m2!1sen!2seg"
                width="500"
                height="250"
                allowFullScreen
                loading="lazy"
                title="Responsive Google Map"
              ></iframe>
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={2} className="tables-section">
        <Grid item xs={5.5}>
          <Paper
            sx={{
              borderRadius: '2rem', // Add border-radius here
              overflow: 'hidden',   // Important for rounded corners on Table
            }}
          >
            <Table className="mui-table">
              <TableHead className="table-header-row">
                <TableRow>
                  {['Order ID', 'Service', 'Distance', 'Time', 'Profit'].map((header, index, arr) => (
                    <TableCell
                      key={header}
                      className="table-header-cell"
                      sx={{
                        ...(index === 0 && { borderTopLeftRadius: '2rem' }),         // First cell
                        ...(index === arr.length - 1 && { borderTopRightRadius: '2rem' }), // Last cell
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody className="table-body">
                <TableRow className="order-time-row" style={{ backgroundColor: '#696969' }}>
                  <TableCell colSpan={5} className="order-time-cell">
                    <Typography className="order-time-text" style={{ color: '#fff' }}>
                      Orders from 09:00 am to 12:00 pm
                    </Typography>
                  </TableCell>
                </TableRow>

                {agentOrders.map((order) => (
                  <TableRow key={order} hover className="table-data-row">
                    <TableCell className="table-checkbox-cell"><Checkbox size="small" /></TableCell>
                    <TableCell className="service-cell">{/* Service Icons */}</TableCell>
                    <TableCell className="table-distance-cell">01:02 Km</TableCell>
                    <TableCell className="table-time-cell">35 mins</TableCell>
                    <TableCell className="table-profit-cell">{order?.total_price} EGP</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid>

        <Grid item xs={1} className="arrows-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div className="arrow-container">
            <button className="arrow-button">
              <span className="arrow right-arrow">→</span>
            </button>
            <button className="arrow-button">
              <span className="arrow left-arrow">←</span>
            </button>
          </div>
        </Grid>

        {/* <Grid item xs={5.5}>
          <Paper
            sx={{
              borderRadius: '2rem',
              overflow: 'hidden',   
            }}
          >
            <Table className="mui-table">
              <TableHead className="table-header-row">
                <TableRow>
                  {['Order ID', 'Service', 'Distance', 'Time', 'Profit'].map((header, index, arr) => (
                    <TableCell
                      key={header}
                      className="table-header-cell"
                      sx={{
                        ...(index === 0 && { borderTopLeftRadius: '16px' }),         
                        ...(index === arr.length - 1 && { borderTopRightRadius: '16px' }),
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody className="table-body">
                <TableRow className="order-time-row" sx={{ backgroundColor: '#f0f0f0' }}>
                  <TableCell colSpan={5} className="order-time-cell">
                    <Typography className="order-time-text">Orders from 09:00 am to 12:00 pm</Typography>
                  </TableCell>
                </TableRow>
                {[1, 2, 3, 4, 5, 6, 7].map((order) => (
                  <TableRow key={order} hover className="table-data-row">
                    <TableCell className="table-checkbox-cell"><Checkbox size="small" /></TableCell>
                    <TableCell className="service-cell"></TableCell>
                    <TableCell className="table-distance-cell">01:02 Km</TableCell>
                    <TableCell className="table-time-cell">35 mins</TableCell>
                    <TableCell className="table-profit-cell">900 EGP</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default ArrangeOrders;